import { render, staticRenderFns } from "./ProductRecommendationSlider.vue?vue&type=template&id=86d368aa"
import script from "./ProductRecommendationSlider.vue?vue&type=script&lang=js"
export * from "./ProductRecommendationSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports